"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.set_daily_food_items = exports.set_user_data = exports.set_username = exports.set_logged_in = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initial_state = {
    logged_in: false,
    username: null,
    // food_items_today: [],
    daily_food_items: [],
    recent_foods: [],
    user_data: {
        username: null,
        daily_calorie_target: 0
    }
};
var default_slice = (0, toolkit_1.createSlice)({
    name: 'slice',
    initialState: initial_state,
    reducers: {
        set_logged_in: function (state, action) {
            state.logged_in = action.payload;
        },
        set_username: function (state, action) {
            state.username = action.payload;
        },
        // set_food_items_today: (state, action) => {
        //     state.food_items_today = action.payload;
        // },
        // set_add_food_selection: (state, action) => {
        //     state.add_food_selection = action.payload;
        // },
        set_recent_foods: function (state, action) {
            state.recent_foods = action.payload;
        },
        set_user_data: function (state, action) {
            state.user_data = action.payload;
        },
        set_daily_food_items: function (state, action) {
            state.daily_food_items = action.payload;
        }
    }
});
var reducer = (0, toolkit_1.combineReducers)({
    default: default_slice.reducer
});
exports.set_logged_in = (_a = default_slice.actions, _a.set_logged_in), exports.set_username = _a.set_username, 
// set_food_items_today,
// set_add_food_selection,
exports.set_user_data = _a.set_user_data, exports.set_daily_food_items = _a.set_daily_food_items;
exports.default = default_slice.reducer;
exports.store = (0, toolkit_1.configureStore)({ reducer: reducer });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdG9yZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLDRDQUE4RjtBQWM5RixJQUFNLGFBQWEsR0FBa0I7SUFDakMsU0FBUyxFQUFFLEtBQUs7SUFDaEIsUUFBUSxFQUFFLElBQUk7SUFDZCx3QkFBd0I7SUFDeEIsZ0JBQWdCLEVBQUUsRUFBRTtJQUNwQixZQUFZLEVBQUUsRUFBRTtJQUNoQixTQUFTLEVBQUU7UUFDUCxRQUFRLEVBQUUsSUFBSTtRQUNkLG9CQUFvQixFQUFFLENBQUM7S0FDMUI7Q0FDSixDQUFDO0FBRUYsSUFBTSxhQUFhLEdBQUcsSUFBQSxxQkFBVyxFQUFDO0lBQzlCLElBQUksRUFBRSxPQUFPO0lBQ2IsWUFBWSxFQUFFLGFBQWE7SUFDM0IsUUFBUSxFQUFFO1FBQ04sYUFBYSxFQUFFLFVBQUMsS0FBSyxFQUFFLE1BQU07WUFDekIsS0FBSyxDQUFDLFNBQVMsR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQ3JDLENBQUM7UUFFRCxZQUFZLEVBQUUsVUFBQyxLQUFLLEVBQUUsTUFBTTtZQUN4QixLQUFLLENBQUMsUUFBUSxHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUM7UUFDcEMsQ0FBQztRQUVELDZDQUE2QztRQUM3QywrQ0FBK0M7UUFDL0MsS0FBSztRQUVMLCtDQUErQztRQUMvQyxpREFBaUQ7UUFDakQsS0FBSztRQUVMLGdCQUFnQixFQUFFLFVBQUMsS0FBSyxFQUFFLE1BQU07WUFDNUIsS0FBSyxDQUFDLFlBQVksR0FBRyxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQ3hDLENBQUM7UUFFRCxhQUFhLEVBQUUsVUFBQyxLQUFLLEVBQUUsTUFBTTtZQUN6QixLQUFLLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUM7UUFDckMsQ0FBQztRQUVELG9CQUFvQixFQUFFLFVBQUMsS0FBSyxFQUFFLE1BQU07WUFDaEMsS0FBSyxDQUFDLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUM7UUFDNUMsQ0FBQztLQUNKO0NBQ0osQ0FBQyxDQUFDO0FBRUgsSUFBTSxPQUFPLEdBQUcsSUFBQSx5QkFBZSxFQUFDO0lBQzVCLE9BQU8sRUFBRSxhQUFhLENBQUMsT0FBTztDQUNqQyxDQUFDLENBQUE7QUFLRSxRQUFBLGFBQWEsSUFESixLQU9ULGFBQWEsQ0FBQyxPQUFPLHFCQUxyQixRQUFBLFlBQVk7QUFDWix3QkFBd0I7QUFDeEIsMEJBQTBCO0FBQzFCLFFBQUEsYUFBYSxxQkFDYixRQUFBLG9CQUFvQiwyQkFDRTtBQUUxQixrQkFBZSxhQUFhLENBQUMsT0FBTyxDQUFDO0FBRXhCLFFBQUEsS0FBSyxHQUFHLElBQUEsd0JBQWMsRUFBQyxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUMsQ0FBQyxDQUFDIn0=